import React, { Component } from "react";

import Dropzone from "react-dropzone";
import { i18n } from "../../translate/i18n";

import { DropContainer, UploadMessage, UploadMessageUnder } from "./styles";

export default class Upload extends Component {
  renderDragMessage = (isDragActive, isDragReject) => {
    if (!isDragActive) {
      return (
        <>
          <UploadMessage>{i18n.t('uploadMessage.click')}</UploadMessage>
          <UploadMessageUnder>(.jpeg, .jpg, .png, .pdf, word, excel, power point)</UploadMessageUnder>
        </>
      )
    }

    if (isDragReject) {
      return (
        <>
          <UploadMessage type="error">{i18n.t('uploadMessage.error')}</UploadMessage>
          <UploadMessageUnder>(.jpeg, .jpg, .png, .pdf, word, excel, power point)</UploadMessageUnder>
        </>
      )
    }

    return (
      <>
        <UploadMessage type="success">{i18n.t('uploadMessage.success')}</UploadMessage>
        <UploadMessageUnder>(.jpeg, .jpg, .png, .pdf, word, excel, power point)</UploadMessageUnder>
      </>
    )
  };

  render() {
    const { onUpload, style, disabled } = this.props;

    return (
      <Dropzone
        accept="image/*, application/pdf, application/vnd.ms-powerpoint, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword"
        onDropAccepted={onUpload}
        disabled={disabled}>
        {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
          <DropContainer
            style={{...style, cursor: disabled ? 'default' : 'pointer' }}
            {...getRootProps()}
            isDragActive={isDragActive}
            isDragReject={isDragReject}
            disabled={disabled}
          >
            <input {...getInputProps()} />
            {this.renderDragMessage(isDragActive, isDragReject)}
          </DropContainer>
        )}
      </Dropzone>
    );
  }
}